export { default } from './components/Dashboard';
